module.exports = __webpack_public_path__ + "5b30c92b6258b4718b855db52d496609.png";